import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Navbar, Nav, Button, Container, Col, Form, Row } from 'react-bootstrap';

const Header = () => {
  return (
    <>
      <Navbar expand="lg" className="py-3 fixed-top nav-bg border-0">
        <Container>
          <Navbar.Brand as={Link} to="/" className="fs-3 fw-600 text-start">LeadStream</Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarSupportedContent" />
          <Navbar.Collapse id="navbarSupportedContent">
          <Nav className="ms-3 nav-menu mb-2 mb-lg-0">

              <Nav.Item className="mx-0 text-decoration-none" as={NavLink} to="/ServicesList" >
               <Button variant="btn-primary" className="mx-1 fw-500">Find Services</Button>
              </Nav.Item>


              <Nav.Item className="mx-0 text-decoration-none" as={NavLink} to="/ProductList" >
                <Button variant="btn-primary" className="mx-1 fw-500">Find Products</Button>
              </Nav.Item>

              <Nav.Item className="mx-0 text-decoration-none" as={NavLink} to="/Get3Quotes">
                <Button variant="btn-primary" className="mx-1 fw-500">Get3Quotes</Button>
              </Nav.Item>


                            <Nav.Item className='m-0 text-decoration-none' as={NavLink} to="/Forum">
                              <Button variant="btn-primary" className="mx-1 fw-500">Forum</Button>
                            </Nav.Item>

              <Nav.Item className="mx-0 text-decoration-none" as={NavLink} to="/LoginPage">
                <Button variant="btn-primary"  className="mx-1 fw-500">Write a Review</Button>
              </Nav.Item>
            </Nav>


<Nav className="ms-auto mb-2 mb-lg-0 d-flex flex-column flex-md-row align-items-center">
  <Nav.Item className="mb-2 mb-md-0">
    <Button variant="btn-primary" as={Link} to="/LoginPage" className="me-md-4 px-4 py-2 fs-6 fw-600 btn-sm btn-outline-primary text-primary rounded-5">
      Sign in
    </Button>
  </Nav.Item>
  <Nav.Item>
    <Button variant="btn-primary" as={Link} to="/SignupPage" className="px-4 py-2 fs-6 fw-600 btn-sm bg-primary text-white rounded-5">
      Get Started
    </Button>
  </Nav.Item>
</Nav>


          </Navbar.Collapse>






          
        </Container>
      </Navbar>

      {/* Sub-header section */}
      <div className="sub-header py-3 bg-light border-bottom border-top">
  <Container>
    <Row className="align-items-start">
      <Col md={7}>
        <Nav className="justify-content-start">
          <Nav.Item>
            <Nav.Link as={Link} to="/category1" className="text-dark">Development</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/category2" className="text-dark">IT Services</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/category3" className="text-dark">Marketing</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/category2" className="text-dark">Design</Nav.Link>
          </Nav.Item>
        </Nav>
      </Col>
      <Col md={5}>
        <Form className="d-flex">
          <Form.Control
            type="search"
            placeholder="e.g. App Development, UX Design, IT Services..."
            className="me-2 px-4 rounded-5"
            aria-label="Search"
          />
        </Form>
      </Col>
    </Row>
  </Container>
</div>
    </>
  );
};

export default Header;